import React, { Component } from 'react'
import TableC from '../../basicElement/TableC';
import SearchRetrieve from '../../common/SearchRetrieve.new';
import API_URL from '../../../common/url';
import Fetch from '../../../common/Fetch';
import dictCache from '../../../common/dictCache';
import { Select, Button, DatePicker, Checkbox, message } from 'antd';
import moment from 'moment';
import $ from '../../../common/AjaxRequest';
const { MonthPicker } = DatePicker;

class Filter extends Component {

    state = {
        asYet: false,
        params: {},
        businessList: [],
        lastMonth: '',
    }

    componentDidMount(){
        this.getTime();
        this.queryWithLevelByParams();
    }

    getTime = () => {
        dictCache.getDict('EFFECTIVE_DATE', cb => {
            Fetch.post(API_URL.home.queryEffectiveDate,{
            }).then(cb)
            .catch(err => {
                console.error(err);
            });
        }, res => {
            const { search } = this.props;
            this.setState({
                lastMonth: `${res.year}-${res.month}`,
                params:{
                    beginDate:  `${res.year}-${res.month}`,
                    endDate: `${res.year}-${res.month}`,
                }
            },() => search(this.state.params))
        });
    }

    queryWithLevelByParams = () => {
        dictCache.getDict('LINE_OF_BUSINESS', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.common.queryWithLevelByParams,
                data: { typeName: 'LINE_OF_BUSINESS' },
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            const typeConfigureList = res.typeConfigureList.slice();
            typeConfigureList.unshift({ typeConfigureId: null, typeValue: '所有项目'})
            this.setState({ businessList: typeConfigureList || [] });
        });
    }

    handleChange = (value, key) => {
        const { params } = this.state;
        console.log(value, key);
        if( key === 'customerCompany' || key === 'leaderUser' ){
            params[`${key}Name`] = value.text;
            params[`${key}Id`] = value.value;
        }else{
            params[key] = value;
        }
        this.setState({
            params
        })
    }

    checkboxChange = () => {
        let { asYet, params } = this.state;
        asYet = !asYet;
            params.toNow = asYet ? '1' : undefined;
        this.setState({
            asYet,
            params,
        })
    }

    disabledDate = (current, key) => {
        const { params: { beginDate, endDate } } = this.state;
        return key === 'disabledEndDate'? current < moment(beginDate) : current > moment(endDate);
    }

    render() {
        const { search, exportData } = this.props;
        const { asYet, params, businessList, lastMonth } = this.state;
        const { beginDate, endDate, customerCompanyName, leaderUserId, lineOfBusinessId } = params
        const Option = Select.Option;
        const businessOption = businessList.map(i => <Option key={String(i.typeConfigureId)}>{i.typeValue}</Option>);
        return (
            <div>
            <div className="search-bar">
                <div className="search-item">
                    <label htmlFor="" className="ui-label">统计时间</label>
                    <MonthPicker
                        disabled={asYet}
                        disabledDate={(current) => this.disabledDate(current, 'disabledBeginDate')}
                        value={moment(beginDate?beginDate:lastMonth)}
                        allowClear={false}
                        style={{ width: 100 }}
                        onChange={(date, dateString) => this.handleChange(dateString, 'beginDate')}
                    />
                    <label className="ui-label" style={{ marginLeft: '10px' }}>
                        至
                    </label>
                    <MonthPicker
                        disabled={asYet}
                        disabledDate={(current) => this.disabledDate(current, 'disabledEndDate')}
                        value={moment(endDate?endDate:lastMonth)}
                        allowClear={false}
                        style={{ width: 100 }}
                        onChange={(date, dateString) => this.handleChange(dateString, 'endDate')}
                    />
                </div>
                <div className="search-item">
                    <label htmlFor="" className="ui-label"><Checkbox onChange={this.checkboxChange}>项目开始至今</Checkbox></label>
                </div>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">客户名称</label>
                    <SearchRetrieve
                        keyword='customerCompanyName'
                        style={{ width: 140 }}
                        placeholder="请输入客户名称检索"
                        value={customerCompanyName}
                        params={{ limit: 20 }}
                        url={API_URL.investigation.queryCustomerCompanyByName}
                        config={{ id: 'customerCompanyId', name: 'customerCompanyName' }}
                        onChange={option => this.handleChange(option, 'customerCompany')}
                    />
                </div>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">领域leader</label>
                    <SearchRetrieve
                        keyword='leaderName'
                        style={{ width: 120 }}
                        placeholder="输入姓名/工号检索"
                        value={leaderUserId}
                        params={{ limit: 20 }}
                        url={API_URL.user.queryLeaderList}
                        config={{ id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }}
                        onChange={value => this.handleChange(value, 'leaderUser')}
                    />
                </div>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">业务线</label>
                    <Select
                        placeholder="请选择"
                        style={{width:120}}
                        allowClear={true}
                        value={lineOfBusinessId}
                        onChange={value => this.handleChange(value, 'lineOfBusinessId')}
                    >
                        {businessOption}
                    </Select>
                </div>
                <div className="search-bar flex-end" >
                    <div className="search-item">
                        <Button type="primary" onClick={() => search( params )}>搜索</Button>
                        <Button type="primary" onClick={exportData}>导出</Button>
                    </div>
                </div>
            </div>
        </div>
        );
    }
}

export default class ProjectDataStatistics extends Component {

    state = {
        data: [],
        pagination: {
            pageSize: 10,
            current: 1,
        }, 
        searchParams:{},
    }

    handleTableChange = (pagination) => {
        this.setState({
            pagination: pagination.pagination,
        },() => this.loadData())
    }

    getColumns = () => {
        const columns = [
        {
            title: '统计月份',
            dataIndex: 'yearMonth',
            key: 'yearMonth',
            width: 80,
        }, {
            title: '客户名称',
            dataIndex: 'customerCompanyName',
            key: 'customerCompanyName',
            width: 80,
        }, {
            title: '客户JDE号',
            dataIndex: 'customerCompanyCode',
            key: 'customerCompanyCode',
            width: 100,
        }, {
            title: '客户性质',
            dataIndex: 'customerCompanyNatureName',
            key: 'customerCompanyNatureName',
            width: 100,
        }, {
            title: '客户关联医院',
            dataIndex: 'hospitalName',
            key: 'hospitalName',
            width: 100,
        }, {
            title: 'JDE主项目',
            dataIndex: 'mainJdeCode',
            key: 'mainJdeCode',
            width: 100,
        }, {
            title: '项目下客户首份签署完成合同的JDE项目号',
            dataIndex: 'earliestCustomerJdeCode',
            key: 'earliestCustomerJdeCode',
            width: 100,
        }, {
            title: '项目简称',
            dataIndex: 'investigationName',
            key: 'investigationName',
            width: 100,
        }, {
            title: '申办方',
            dataIndex: 'investigationSponsor',
            key: 'investigationSponsor',
            width: 100,
        }, {
            title: '业务线',
            dataIndex: 'lineOfBusinessString',
            key: 'lineOfBusinessString',
            width: 100,
        }, {
            title: '执行业务线二级分类',
            dataIndex: 'secondLineName',
            key: 'secondLineName',
            width: 100,
        }, {
            title: '项目阶段',
            dataIndex: 'stageNames',
            key: 'stageNames',
            width: 100,
        }, {
            title: '大项目经理',
            dataIndex: 'pmUser',
            key: 'pmUser',
            width: 100,
        }, {
            title: '人员姓名',
            dataIndex: 'userCompellation',
            key: 'userCompellation',
            width: 100,
        }, {
            title: '工号',
            dataIndex: 'employeeCode',
            key: 'employeeCode',
            width: 100,
        }, {
            title: '工作城市',
            dataIndex: 'workCity',
            key: 'workCity',
            width: 100,
        }, {
            title: '职位',
            dataIndex: 'positionName',
            key: 'positionName',
            width: 100,
        }, {
            title: '公司代码',
            dataIndex: 'companyCode',
            key: 'companyCode',
            width: 100,
        }, {
            title: '公司名称',
            dataIndex: 'companyName',
            key: 'companyName',
            width: 100,
        }, {
            title: '中心区域',
            dataIndex: 'areaName',
            key: 'areaName',
            width: 100,
        }, {
            title: '中心城市',
            dataIndex: 'cityName',
            key: 'cityName',
            width: 100,
        }, {
            title: '研究中心',
            dataIndex: 'investigationSiteName',
            key: 'investigationSiteName',
            width: 100,
        }, {
            title: '项目角色',
            dataIndex: 'roleCode',
            key: 'roleCode',
            width: 100,
        }, {
            title: '截止当月累计计入完工的项目确认FTE',
            dataIndex: 'accumulativeFte',
            key: 'accumulativeFte',
            width: 100,
        }, {
            title: '当月计入完工的项目确认FTE',
            dataIndex: 'consumeFte',
            key: 'consumeFte',
            width: 100,
        }, {
            title: '截止当月累计项目确认FTE',
            dataIndex: 'invAccumulativeFte',
            key: 'invAccumulativeFte',
            width: 100,
        }, {
            title: '当月项目确认FTE',
            dataIndex: 'invConsumeFte',
            key: 'invConsumeFte',
            width: 100,
        }];
        return columns;
    }

    loadData = ( ) => {
        const { searchParams, pagination } = this.state;
        const { current, pageSize } = pagination;
        const { lineOfBusinessId } = searchParams;
        Fetch.post(API_URL.dashboard.queryInvCustomerList, {
            offset: current,
            limit: pageSize,
            ...searchParams,
            lineOfBusinessId: lineOfBusinessId=='null'?undefined:lineOfBusinessId
        }).then(res => {
            const { datas, totalCount } = res;
                pagination.total = totalCount;
                this.setState({
                    loading: false,
                    data: datas,
                    pagination,
                });
        }).catch(err => {
            console.error(err);
        });
    }

    search = (searchParams) => {
        const { pagination } = this.state;
        pagination.current = 1;
        this.setState({
            pagination,
            searchParams,
        }, () => this.loadData());
    }

    export = () => {
        const { searchParams } = this.state;
        Fetch.post(API_URL.dashboard.exportInvCustomerList,{
            ...searchParams
        }).then(res => {
            message.success(res.success);
        }).catch(err => {
            console.error(err);
        });
    }

    render() {
        const { data, pagination } = this.state;
        return (
        <div>
            <div className="reportTitle">{this.props.title}</div>
            <Filter
                search={this.search}
                exportData={this.export}
            />
            <div style={{marginBottom: 5, color: '#ffa500'}}>{`注：由于数据量过大，页面仅展示其中一个项目的数据，请导出后查看完整数据`}</div>
            <TableC
                data={data}
                scrollY={500}
                columns={this.getColumns()}
                pagination={pagination}
                onChange={this.handleTableChange}
            />
        </div>
        )
    }
    }



// WEBPACK FOOTER //
// ./src/components/homePage/statement/projectDataStatistics.js